import React, { useContext } from 'react';
import LoginLanding from '../Components/LoginLanding';
import { DataContext } from '../Context/dataContext';
import educatorImg from '../images/educatorImg.png';
import { ForgotPswrdModal } from './ForgotPassword';

const EducatorLogin = () => {
    const dataContext = useContext(DataContext)
    // console.log(dataContext.fPswrdComponent)
    return (
        <>
            { (dataContext.fPswrdComponent === 'school staff' || dataContext.fPswrdComponent === '')  && <ForgotPswrdModal />}
            <LoginLanding
                HeadingText = 'Easily manage all your school processes and activities'
                subHeadingText = 'can use Edves to manage all activities from enrollment to attendance, calendar, timetable, growth tracking, student records, scheduling tests/exams, sharing assignments, class notes...'
                subHeadingHighlight = 'School Staff'
                img = {educatorImg}
                person = 'school staff'
                loginBar1 = 'Log in as a School Staff'
                loginBar2 = 'Log in as a Parent'
                loginBar3 = 'Log in as a Student'
            />
        </>
    )
}

export default EducatorLogin;